module.exports = __webpack_public_path__ + "img/expired.5c597785.svg";